import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ImportContainer } from "../../../Model/dataProcess/importContainer";
import { LoginService } from "../../../Services/login.service";
import { PreparationContainer } from "../../../Model/dataProcess/PreparationContainer";
import { PreparationContainerService } from "../../../Services/DataProcess/preparation-container.service";
import { CatalogService } from "../../../Services/CatalogManagement/catalog.service";
import { DxContextMenuComponent } from "devextreme-angular";
import { TranslateService } from "@ngx-translate/core";
import { SystemService } from "../../../Services/system.service";
import { confirm } from "devextreme/ui/dialog";

@Component({
    selector: 'app-prepare-stage',
    templateUrl: './prepare-stage.component.html',
    styleUrls: ['./prepare-stage.component.css'],
    standalone: false
})
export class PrepareStageComponent implements OnInit {

    @ViewChild('rowMenu', { static: false })
    rowMenu?: DxContextMenuComponent;
    @Output() containerSaved = new EventEmitter<ImportContainer>();
    public selectedCatalogId: string | null = null;
    public container: ImportContainer = null;
    public preparationContainer: PreparationContainer = null;
    public preparationCatalogs: { id: string; name: string }[] = [];
    public archivCatalogs: { id: string; name: string }[] = [];
    public isArchiveLoading: boolean = false;

    public searchEditorOptions = {
        placeholder: this.translate.instant('Suchen…'),
        showClearButton: true
    };

    public searchEditorOptionsArchive = {
        placeholder: this.translate.instant('Archiv durchsuchen…'),
        showClearButton: true
    };

    public rowMenuItems = [
        { id: 'archive', text: this.translate.instant('Katalog ins Archiv verschieben') },
        { id: 'delete', text: this.translate.instant('Katalog löschen') },
    ];

    constructor(
        private readonly router: Router,
        private readonly loginService: LoginService,
        private readonly preparationContainerService: PreparationContainerService,
        private readonly catalogService: CatalogService,
        private readonly translate: TranslateService,
        private readonly systemService: SystemService
    ) {
        this.systemService.currentNavigationTitle = this.translate.instant('Preparation');
        this.loadCatalogLists = this.loadCatalogLists.bind(this);
    }

    async ngOnInit() {
        this.preparationContainer = await this.preparationContainerService.getPreparationContainer(this.loginService.currentCustomer.id);
        await this.loadCatalogLists();
    }

    async onMenuItemClick(event: any) {
        switch (event.itemData.id) {
            case 'archive':
                await this.moveCatalog(true);
                break;
            case 'restore':
                await this.moveCatalog(false);
                break;
            case 'delete':
                await this.deleteCatalog();
                break;
        }
    }

    private async moveCatalog(toArchive: boolean) {
        this.preparationContainer =
            await this.preparationContainerService.moveCatalog(
                this.selectedCatalogId,
                this.preparationContainer.id,
                toArchive,
                this.loginService.currentCustomer.id
            )
        if (this.preparationContainer) {
            await this.loadCatalogLists();
            this.systemService.notifyInfo(this.translate.instant('Katalog erfolgreich verschoben'));
        }
    }

    private async deleteCatalog() {
        if (!this.selectedCatalogId) {
            return;
        }
        const confirmed = await confirm(
            this.translate.instant('Wollen Sie den Katalog wirklich löschen?'),
            this.translate.instant('Katalog löschen')
        );
        if (!confirmed) {
            return;
        }

        const catalogId = this.selectedCatalogId;
        this.preparationCatalogs = this.preparationCatalogs.filter(c => c.id !== catalogId);
        this.archivCatalogs = this.archivCatalogs.filter(c => c.id !== catalogId);
        this.selectedCatalogId = null;

        this.preparationContainer =
            await this.preparationContainerService.removeCatalog(
                catalogId,
                this.preparationContainer.id,
                this.loginService.currentCustomer.id
            );
        await this.loadCatalogLists();
        this.systemService.notifyInfo(this.translate.instant('Katalog erfolgreich gelöscht'));
    }

    onCatalogRowClick(catalogId: string | null | undefined): void {
        if (!catalogId) {
            return;
        }
        this.selectedCatalogId = catalogId;
    }

    onOpenCatalogClicked(catalogId: string | null | undefined): void {
        if (!catalogId) {
            return;
        }
        const customerId = this.loginService.currentCustomer.id;
        this.router.navigate(['/dataprocess/preparation/catalog', customerId, catalogId, 'infos']);
    }

    openPreparationRowMenu(e: any) {
        this.rowMenuItems = [
            { id: 'archive', text: this.translate.instant('Katalog ins Archiv verschieben') },
            { id: 'delete', text: this.translate.instant('Katalog löschen') },
        ];
        this.showRowMenu(e);
    }

    openArchiveRowMenu(e: any) {
        this.rowMenuItems = [
            { id: 'restore', text: this.translate.instant('Katalog aus Archiv wiederherstellen') },
            { id: 'delete', text: this.translate.instant('Katalog löschen') },
        ];
        this.showRowMenu(e);
    }

    private showRowMenu(e: any) {
        const targetElement = e.element as HTMLElement;
        this.rowMenu?.instance.option('target', targetElement);
        this.rowMenu?.instance.show();
    }

    private async loadCatalogLists() {
        const customerId = this.loginService.currentCustomer.id;
        await this.catalogService.setCatalogs(customerId);
        this.preparationCatalogs = await Promise.all(
            this.preparationContainer.preparationCatalogIds.map(async id => {
                const fromList = this.catalogService.catalogs?.find(c => c.id === id);
                const name = fromList?.catalogName
                    ?? await this.catalogService.getCatalogName(id, customerId);
                return { id, name };
            })
        );
        this.archivCatalogs = await Promise.all(
            this.preparationContainer.archivCatalogIds.map(async id => {
                const fromList = this.catalogService.catalogs?.find(c => c.id === id);
                const name = fromList?.catalogName
                    ?? await this.catalogService.getCatalogName(id, customerId);
                return { id, name };
            })
        );
    }
}
